// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__3_4hI","obliqueLineWrap":"membershipbadge_obliqueLineWrap__22uLe","obliqueLine":"membershipbadge_obliqueLine__E5A36"};